import { Swiper, SwiperSlide } from "swiper/react";
import { BASE_URL } from '../constants';
import "swiper/css";
// import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper/modules";

export default function HomeSlider({ sliders = [] }) {
  const BASE_IMAGE_URL = BASE_URL;
  // default slider used when no sliders
   const defaultSlides = [
    "/assets/images/slider/img-1.jpg",
    "/assets/images/slider/img-2.jpg",
    "/assets/images/slider/img-3.jpg",
   ];


   const dataToShow = sliders.length > 0 ? sliders : defaultSlides;
  //  console.log(dataToShow,'Azim khan');
  return (
<Swiper
      modules={[Pagination, Autoplay]}
      slidesPerView={1}
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000 }}
      loop={true}
      className="w-screen custom-swiper"
    >
      {dataToShow.map((item, index) => (
        <SwiperSlide key={index}>
          <img
            src={`${BASE_IMAGE_URL}/${item.image}`}
            className="w-full h-[520px] object-cover"
            alt={`slide-${index}`}
          />
        </SwiperSlide>
      ))}
    </Swiper>
    
    /*
    <Swiper
      modules={[Pagination, Autoplay]}
      slidesPerView={1}
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000 }}
      loop
      className="w-screen custom-swiper"
    >
      
      <SwiperSlide>
        <img
          src="/assets/images/slider/img-1.jpg"
          className="w-full h-[520px] object-cover"
          alt=""
        />
      </SwiperSlide>

      <SwiperSlide>
        <img
          src="/assets/images/slider/img-2.jpg"
          className="w-full h-[520px] object-cover"
          alt=""
        />
      </SwiperSlide>

      <SwiperSlide>
        <img
          src="/assets/images/slider/img-3.jpg"
          className="w-full h-[520px] object-cover"
          alt=""
        />
      </SwiperSlide>

      {/* <SwiperSlide>
        <img
          src="/assets/images/slider/img-4.jpg"
          className="w-full h-[520px] object-cover"
          alt=""
        />
      </SwiperSlide> 
    </Swiper>
*/

  );
}
